import { isEmpty } from 'lodash-es';
import { theme } from '@dojo/framework/core/middleware/theme';
import { create, destroy, v, w } from '@dojo/framework/core/vdom';
import { createICacheMiddleware } from '@dojo/framework/core/middleware/icache';
import Dialog from '@dojo/widgets/dialog';
import { createNlsMiddleware, landingChange, userstate } from '@holmescorp/lcc-state';
import { Hero, Layout, LearnerTools, StudyView, MCWhereYouLeftOff, OverallProgress } from '@holmescorp/mc-widgets';
import { Video } from '@holmescorp/video';
import { Icon } from '@holmescorp/base-widgets';
import { Keys } from '@holmescorp/common';
import css from '../css/micro-view.m.css';
const factory = create({
    theme,
    userstate,
    destroy,
    settings: createNlsMiddleware('settings'),
    icache: createICacheMiddleware()
}).properties();
export const MicroView = factory(({ id: instanceId, middleware: { theme, userstate, destroy, settings, icache } }) => {
    globalThis.document.getElementById('content-main')?.classList.add('study');
    destroy(() => globalThis.document.getElementById('content-main')?.classList.remove('study'));
    const themeCss = theme.classes(css);
    const id = 'micro-view';
    const widgetId = `${id}-${instanceId}`;
    const { messages: { title = '[settings] title', intro_header = '[settings] intro_header', intro_body = '[settings] intro_body', intro_success_header = '[settings] intro_success_header', intro_success_body = '[settings] intro_success_body', intro_success_image = '' } } = settings();
    const { get, path } = userstate;
    const tracking = get(path('toolstate', 'trackingwylo'));
    const { complete: landingCompleted = false } = get(path('toolstate', 'landing'));
    const { survey } = get(path('toolstate', 'posttest')) || {};
    const surveyCompleted = survey?.completed || false;
    const showDialog = icache.getOrSet('showDialog', !landingCompleted);
    const markComplete = () => {
        landingChange({ complete: true });
        icache.set('showDialog', false);
    };
    return v('div', { id: `${id}-main`, classes: [themeCss.root, theme.variant()] }, [
        v('div', { id: `${id}-title`, classes: [css.header] }, [v('h3', {}, [title])]),
        v('div', {
            id,
            widgetId,
            key: widgetId,
            xqa: `${id}-layout`,
            classes: [themeCss.root]
        }, [
            w(Layout, {
                xqa: `${id}-layout-widget`,
                id: `${id}-layout-widget-${instanceId}`,
                key: `${id}-two-column-layout`
            }, [
                {
                    leading: v('div', { classes: [themeCss.leading] }, [
                        w(Hero, { additionalClasses: [themeCss.hero] }, surveyCompleted
                            ? [
                                v('div', { classes: [themeCss.success] }, [
                                    intro_success_image
                                        ? v('img', {
                                            src: intro_success_image,
                                            classes: [themeCss.badge]
                                        })
                                        : null,
                                    v('div', {}, [
                                        v('h2', { classes: [themeCss.title] }, [
                                            intro_success_header
                                        ]),
                                        v('div', { innerHTML: intro_success_body })
                                    ])
                                ])
                            ]
                            : isEmpty(tracking.tracking)
                                ? [
                                    v('div', { classes: [themeCss.intro] }, [
                                        v('h2', { classes: [themeCss.title] }, [intro_header]),
                                        v('div', { innerHTML: intro_body })
                                    ])
                                ]
                                : [w(MCWhereYouLeftOff, {}), w(OverallProgress, {})]),
                        w(StudyView, {})
                    ]),
                    trailing: w(LearnerTools, {})
                }
            ])
        ]),
        !landingCompleted
            ? w(Dialog, {
                open: showDialog,
                underlay: true,
                closeable: false,
                onRequestClose: markComplete
            }, [
                {
                    content: v('div', { key: 'skel', classes: [themeCss.skel] }, [
                        v('div', {
                            classes: [themeCss.close],
                            role: 'button',
                            tabIndex: 0,
                            onclick: markComplete,
                            onkeydown: (event) => {
                                switch (event.key) {
                                    case Keys.Enter:
                                    case Keys.Space:
                                    case Keys.Spacebar:
                                        event.preventDefault();
                                        markComplete();
                                        break;
                                }
                            }
                        }, [w(Icon, { fapre: 'far', faname: 'circle-xmark' })]),
                        w(Video, { videonum: 1 })
                    ])
                }
            ])
            : null
    ]);
});
export default MicroView;
